/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')
module.exports = CAppelFonctionInterne
/**
 * @constructor
 * @extends CCb
 * Objet d'un arbre binaire de calcul représentant un appel de fonction interne.
 * Utilisé dans les calculs de dérivées et dérivées partielles.
 * @param {CCb} fonctionInterne : Pointe sur la fonction à appliquer.
 * @param {CCb} operande : Pointe sur l'opérande.
 * @returns {CAppelFonctionInterne}
 */
function CAppelFonctionInterne (fonctionInterne, operande) {
  CCb.call(this, fonctionInterne.listeProprietaire);
  this.fonctionInterne = fonctionInterne;
  this.operande = operande;
}
CAppelFonctionInterne.prototype = new CCb();
CAppelFonctionInterne.prototype.constructor = CAppelFonctionInterne;
CAppelFonctionInterne.prototype.superClass = "CCb";
CAppelFonctionInterne.prototype.className = "CAppelFonctionInterne";


CAppelFonctionInterne.prototype.nature = function() {
  return CCbGlob.natAppelFonctionInterne;
};

CAppelFonctionInterne.prototype.resultat = function(infoRandom){
  return this.fonctionInterne.resultatFonction(infoRandom,this.operande.resultat(infoRandom));
};

CAppelFonctionInterne.prototype.resultatFonction = function(infoRandom, valeurparametre){
  return this.fonctionInterne.resultatFonction(infoRandom, this.operande.resultatFonction(infoRandom, valeurparametre));
};

CAppelFonctionInterne.prototype.getCopie = function() {
  return new CAppelFonctionInterne(this.fonctionInterne.getCopie(), this.operande.getCopie());
};

CAppelFonctionInterne.prototype.dependDeVariable = function(ind){
  return this.operande.dependDeVariable(ind);
};

CAppelFonctionInterne.prototype.estConstant = function() {
  return this.fonctionInterne.estConstant() && this.operande.estConstant();
};
CAppelFonctionInterne.prototype.deriveePossible = function(indiceVariable) {
  return this.fonctionInterne.deriveePossible(indiceVariable) && this.operande.deriveePossible(indiceVariable);
};

CAppelFonctionInterne.prototype.calculAvecValeursRemplacees = function() {
  return new CAppelFonctionInterne(this.fonctionInterne, this.operande.calculAvecValeursRemplacees());
};

CAppelFonctionInterne.prototype.membreGauche = function() {
  return this.fonctionInterne.membreGauche();
};

CAppelFonctionInterne.prototype.membreDroit = function() {
  return this.fonctionInterne.membreDroit();
};



// WEBPACK FOOTER //
// ./src/objets/CAppelFonctionInterne.js